import { IconProps } from './interfaces';

export const CloseIcon = ({ className }: IconProps) => {
    return (
        <svg className={className} version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="m4.5429 4.5429c0.39053-0.39052 1.0237-0.39052 1.4142 0l6.0429 6.0429 6.0429-6.0429c0.3905-0.39052 1.0237-0.39052 1.4142 0 0.3905 0.39053 0.3905 1.0237 0 1.4142l-6.0429 6.0429 6.0429 6.0429c0.3905 0.3905 0.3905 1.0237 0 1.4142s-1.0237 0.3905-1.4142 0l-6.0429-6.0429-6.0429 6.0429c-0.39053 0.3905-1.0237 0.3905-1.4142 0-0.39052-0.3905-0.39052-1.0237 0-1.4142l6.0429-6.0429-6.0429-6.0429c-0.39052-0.39053-0.39052-1.0237 0-1.4142z"
                clipRule="evenodd"
                fillRule="evenodd"
            />
        </svg>
    );
};
